module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAHCAYAAADnCQYGAAAAiklEQVQoka3OMQ4BURQF0GP8QhS2oCR6CguQTKPWSSxCo6CzAbEGO7ACulEItUqpFR2NUUwhn8xtbl5yc/Iq6TgTmRqWmOH+bZjEinggRYZuWSic0MYec4Qy0PO7AxbYoVUcBTRRjURvhbuHA6ZY45mjHWzQ+O3pT+pYYYgJrgm26OPyJ5pngCNGL4boFMVTirAlAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qian_ico.png
// module id = 758
// module chunks = 1